import { Component, effect, inject, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { IconLoaderService } from './service/icon-loader/icon-loader.service';
import { IconName } from './service/icon-loader/icon.register';

@Component({
  selector: 'app-icon',
  imports: [MatIcon],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
})
export class IconComponent {
  private readonly loader = inject(IconLoaderService);

  readonly name = input.required<IconName>();
  readonly size = input(24);
  readonly color = input<string>('inherit');

  constructor() {
    effect(() => {
      this.loader.ensure(this.name());
    });
  }
}
